/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:16
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-03-11 14:30:49
 * @FilePath: \crm-product\src\views\dms\views\sharing_agreement\reward_list\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';

export default {
  extends: TablePage,
  components: {

  },
  name: 'config_list',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('page_list');
  },

  methods: {
    modalClick({ val, row }) {
      console.log(val);
      console.log(row);
      // if (val.code === 'stopHeader') {
      //     console.log(this.selection);
      //     if (!this.selection || this.selection.length === 0) {
      //         return this.$message.error('请至少选择一条数据');
      //     }
      //     request.post('/cps/agreeShare/stopBatch', { ids: this.selection }).then((res) => {
      //         console.log(res);
      //         if (res.success) {
      //             this.$message.success(res.message);
      //             this.getList();
      //         }
      //     });
      // }
      if (val.code === 'oneKeySend') {
        if (!this.selection || this.selection.length === 0) {
          return this.$message.error('请至少选择一条数据');
        }
        const ids = this.selection;
        request.post('/cps/agreeReward/oneclickPayout', { ids }).then((res) => {
          console.log(res);
          if (res.success) {
            this.$message.success(res.message);
            this.getList();
          }
        });
      }
    },
  },
};
